import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import "./assets/css/style.css"

Vue.config.productionTip = false

const Api = require('./api.js').Api;
export const api = new Api();

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
